export default function offerCustomButtonOptionsResolver({ offer, offerSettings, itemSettings, on }) {
    return {
        bind: {
            offer,
            settings: {
                ...itemSettings,
                customButton: offerSettings.customButton,
            },
        },
        on: {
            'custom-button-click': (event) => {
                if (on.customButtonClick) {
                    on.customButtonClick(event);
                }
            },
        },
    };
}